import factory from './icon';
import Svg from './glyphs/close.svg';

export default factory(Svg);
